import { Button } from '@servicetitan/design-system';
import { ComponentProps } from 'react';

interface ClearFiltersProps extends ComponentProps<typeof Button> {
  onClear: () => void;
}

export const ClearFilters = ({ onClear, ...props }: ClearFiltersProps) => {
  return (
    <Button
      {...props}
      primary
      fill='subtle'
      size='xsmall'
      onClick={onClear}
      aria-label='select none'
    >
      Clear Filters
    </Button>
  );
};
